import { PriceAdjustmentDto } from "./PriceAdjustmentDto";
var ShippingItemDto = (function () {
    function ShippingItemDto(basePrice, id, price, priceAdjustments, discountPrice) {
        if (basePrice === void 0) { basePrice = 0; }
        if (id === void 0) { id = ''; }
        if (price === void 0) { price = 0; }
        if (priceAdjustments === void 0) { priceAdjustments = []; }
        if (discountPrice === void 0) { discountPrice = 0; }
        this.basePrice = basePrice;
        this.id = id;
        this.price = price;
        this.priceAdjustments = priceAdjustments;
        this.discountPrice = discountPrice;
    }
    ShippingItemDto.fromOcapi = function (ocapiShippingItem) {
        var _a;
        var priceAdjustments = ((_a = ocapiShippingItem.price_adjustments) === null || _a === void 0 ? void 0 : _a.map(function (pa) { return PriceAdjustmentDto.fromOcapi(pa); })) || [];
        return new ShippingItemDto(ocapiShippingItem.base_price, ocapiShippingItem.item_id, ocapiShippingItem.price, priceAdjustments, ocapiShippingItem.price_after_item_discount);
    };
    return ShippingItemDto;
}());
export { ShippingItemDto };
//# sourceMappingURL=ShippingItemDto.js.map